import React from "react";
import Index from "./index";
import AuthoursTable from "./AuthorsTable";

const Author = () => {
    const { allAuthors, loading, history, search, setSearch, onDelete } = Index();
    return (
        <AuthoursTable
            heading="All Authors"
            allAuthors={allAuthors}
            loading={loading}
            history={history}
            search={search}
            setSearch={setSearch}
            onDelete={onDelete}
        />
    );
};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname && prevProps.colorMode === nextProps.colorMode;
};
export default React.memo(Author, comparisonFn);
